import { Extension } from "@tiptap/core";
import { Plugin } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

export const RedTextAfterLimit = Extension.create<{
	limit: number;
	separatorLength: number;
}>({
	name: "redTextAfterLimit",

	addOptions() {
		return {
			limit: 100,
			// Length of the separator the serialized value inserts between top-level blocks
			// ("\n".length in plain-text mode). Counts toward the limit like it does on submit.
			separatorLength: 0,
		};
	},

	addProseMirrorPlugins() {
		return [
			new Plugin({
				props: {
					decorations: (state) => {
						const decorations: Decoration[] = [];
						let charCount = 0;

						state.doc.descendants((node, pos, parent, index) => {
							// Each top-level block after the first costs one separator in the
							// serialized value — red text must start where the submitted value
							// actually crosses the cap.
							if (parent?.type.name === "doc" && index > 0) {
								charCount += this.options.separatorLength;
							}
							if (!node.isText) return true;

							const nodeTextLength = node?.text?.length ?? 0;
							const nodeStart = charCount;
							const nodeEnd = charCount + nodeTextLength;

							if (nodeEnd > this.options.limit) {
								const from = pos + Math.max(0, this.options.limit - nodeStart);
								const to = pos + nodeTextLength;
								decorations.push(Decoration.inline(from, to, { class: "text-red-500" }));
							}

							charCount = nodeEnd;
							return false;
						});

						return DecorationSet.create(state.doc, decorations);
					},
				},
			}),
		];
	},
});
